module.exports = __webpack_public_path__ + "img/logo-ingeray.593d36bf.svg";